import { createFileRoute } from '@tanstack/react-router'
import { AuditorControlsRoutePage } from '@/components/auditor-center/AuditorCyclePages'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/controls',
)({
  validateSearch: (search: Record<string, unknown>): {
    view?: 'control' | 'requirement'
    test?: string
    control?: string
    requirement?: string
    under?: string
    control_def_id?: string
  } => ({
    ...search,
    view: search.view === 'control' || search.view === 'requirement' ? search.view : undefined,
    test: typeof search.test === 'string' ? search.test : undefined,
    control: typeof search.control === 'string' ? search.control : undefined,
    requirement: typeof search.requirement === 'string' ? search.requirement : undefined,
    under: typeof search.under === 'string' ? search.under : undefined,
    control_def_id: typeof search.control_def_id === 'string' ? search.control_def_id : undefined,
  }),
  // `pad: false` — full-height three-pane review surface; the cycle shell must
  // not wrap it in its p-6 content padding.
  staticData: {
    pageHeader: { title: 'Controls', customHeader: true, pad: false },
  },
  component: AuditorControlsRoutePage,
})
